import React, { useState, useEffect } from 'react';
import MainLayout from './components/layout/MainLayout';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import MemberList from './pages/MemberList';
import MyProfile from './pages/MyProfile';
import ChangePasswordPage from './pages/ChangePasswordPage'; // 비밀번호 변경 전용 페이지 추가

function App() {
  // 1. 앱 로드 시 localStorage에서 사용자 정보 초기화
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const [currentTab, setCurrentTab] = useState('dashboard');

  // 2. user 상태 변경 시 localStorage에 동기화
  useEffect(() => {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      localStorage.removeItem('user');
    }
  }, [user]);

  const handleLoginSuccess = (userData) => {
    setUser(userData);
    setCurrentTab('dashboard');
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  // 비밀번호 변경 성공 시 실행되는 상태 갱신 함수
  const handlePasswordChangeSuccess = () => {
    const updatedUser = { ...user, passwordResetRequired: 'N' };
    setUser(updatedUser);
    localStorage.setItem('user', JSON.stringify(updatedUser));
    setCurrentTab('dashboard'); // 변경 완료 후 메인 대시보드로 이동
  };

  // 로고/협회 문구 클릭 시 메인(대시보드)으로 이동
  const handleLogoClick = () => {
    setCurrentTab('dashboard');
  };

  // 1. 미인증 상태 -> 로그인 화면 렌더링
  if (!user) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  // 2. 로그인 상태이나 초기 비밀번호 변경 대상(Y) -> 다른 화면 차단 후 변경 전용 화면만 렌더링
  if (user.passwordResetRequired === 'Y') {
    return (
      <ChangePasswordPage
        user={user}
        onPasswordChangeSuccess={handlePasswordChangeSuccess}
        onLogout={handleLogout} // 필요 시 로그아웃 기능 전달
      />
    );
  }

  // 3. 비밀번호 변경 완료 사용자 -> 기존 MainLayout 및 탭 화면 렌더링
  return (
    <MainLayout 
      user={user} 
      onLogout={handleLogout}
      currentTab={currentTab}
      setCurrentTab={setCurrentTab}
      onLogoClick={handleLogoClick}
    >
      {/* 탭 네비게이션 렌더링 */}
      {currentTab === 'dashboard' && (
        <Dashboard user={user} onNavigate={setCurrentTab} />
      )}
      {currentTab === 'admin-members' && user?.role === 'ROLE_ADMIN' && <MemberList />}
      {currentTab === 'profile' && <MyProfile user={user} />}
      {currentTab === 'notice' && (
        <div style={{ padding: '20px' }}>
          <h2>협회 소식 & 공지사항</h2>
          <p>공지사항 목록이 준비 중입니다.</p>
        </div>
      )}
    </MainLayout>
  );
}

export default App;